import React from 'react';
import { Box, Typography, Chip, Button, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import logo from '../assets/logo.png';

function JournalHeader() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box
      sx={{
        backgroundColor: '#f2f7fa',
        px: 3,
        py: isMobile ? 3 : 5,
        display: 'flex',
        flexDirection: isMobile ? 'column' : 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        boxShadow: 3,
      }}
    >
      {/* Logo */}
      <Box
        component="img"
        src={logo}
        alt="Journal Logo"
        sx={{
          width: isMobile ? 80 : 100,
          height: 'auto',
          mb: isMobile ? 2 : 0,
        }}
      />

      {/* Journal Info */}
      <Box sx={{ textAlign: isMobile ? 'center' : 'left', flex: 1, px: isMobile ? 0 : 3 }}>
        <Typography
          variant={isMobile ? 'h6' : 'h4'}
          sx={{
            fontWeight: 700,
            fontFamily: 'Poppins, sans-serif',
            color: '#1a237e',
          }}
        >
          West African Journal of Life Sciences
        </Typography>

        <Typography variant="body2" sx={{ mt: 0.5, color: '#333' }}>
          ISSN (Online): 0000-000 &nbsp; | &nbsp; ISSN (Print): 2992-5150 &nbsp; | &nbsp; A multidisciplinary journal for scientific research in West Africa
        </Typography>

        <Chip
          label="Open Access"
          color="success"
          size="small"
          sx={{ mt: 1.5, fontWeight: 600 }}
        />
      </Box>


      
    </Box>
  );
}

export default JournalHeader;
